import {
    faClock,
    faLocationDot,
    faUser,

} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { extractOnlyTwoDigitDate } from "../../../utils/extractOnlyTwoDigitDate";
import { extarctOnlyMonth } from "../../../utils/extarctOnlyMonth";
import { extarctOnlyDay } from "../../../utils/extarctOnlyDay";
import { extractIntoDDMMFormat } from "../../../utils/extractIntoDDMMFormat";
import { formatTimeRange } from "../../../utils/formattedTimeRange";
import { clearJobs, getJobListings } from "../../../redux/reducers/jobsSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { Rating } from "react-simple-star-rating";



const BookingList = ({ status }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const { jobList, currentpage, dataPerPage, dataCount } = useSelector((state) => state.jobs)
    useEffect(() => {
        let bodyData = {
            currentpage: 1,
            limit: 5,
            statusFilter: status ?? 'Upcoming'
        }
        dispatch(getJobListings(bodyData))
        return () => {
            dispatch(clearJobs())
        }
    }, [])
    const loadMoreData = () => {
        if (location.pathname === '/dashboard') {
            navigate('/booking')
        }
        else {
            let bodyData = {
                currentpage: currentpage + 1,
                limit: dataPerPage,
                statusFilter: status ?? 'Upcoming'
            }
            dispatch(getJobListings(bodyData))
        }
    }

    return (
        <>
            <div className="upcoming-box-row">

                {jobList && jobList?.length > 0 ? jobList?.map((item, idx) => {
                    return (
                        <>

                            <div className="upcoming-box-col" key={idx + 1} >
                                <div className="upcoming-date-time-wrap" onClick={() => navigate(`/booking-details/${item?._id}`)}>
                                    <div className="upcoming-date">{extractOnlyTwoDigitDate(item?.startDate)}</div>
                                    <div className="upcoming-month">{extarctOnlyMonth(item?.startDate)}</div>
                                    <div className="upcoming-day"> {extarctOnlyDay(item?.startDate)}</div>
                                </div>

                                <div className="upcoming-box-right" onClick={() => navigate(`/booking-details/${item?._id}`)}>
                                    <div className="upcoming-heading-wrap">
                                        <div className="upcoming-heading">
                                            <h5>
                                                {`${item?.orderType?.charAt(0).toUpperCase()}${item?.orderType?.slice(1)} Cleaning`}
                                                {/* <span className="up-count">{extractIntoDDMMFormat(item?.createdAt)}</span> */}
                                            </h5>
                                        </div>
                                        <div className="upcm-add">
                                            <div className="upcm-add-details">
                                                <ul className="list-unstyled">
                                                    <li>
                                                        {/* <FontAwesomeIcon icon={faLocationDot} /> */}
                                                        <img src="/assets/images/img-icon1.png" />

                                                        {item?.displayAddress?.displayAddress?.title ?? '--'}
                                                    </li>
                                                </ul>
                                            </div>
                                            <ul className="list-unstyled">
                                                <li>
                                                    {/* <FontAwesomeIcon icon={faClock} /> */}
                                                    <img src="/assets/images/img-icon2.png" />

                                                    {formatTimeRange(item?.startDate, item?.endDate)}
                                                </li>
                                                {/* {item?.assignTo && item?.assignTo?.length > 0 && item?.assignTo?.map((assignItem, idxOfAssign) => {
                                                    return (
                                                        <> */}

                                                {item?.staffName && item?.staffName?.length > 0 && <li>

                                                    {/* <FontAwesomeIcon icon={faUser} /> */}
                                                    {item?.staffName?.map((val) => (
                                                        <>
                                                            <img src="/assets/images/img-icon3 (1).png" />
                                                            {val}</>
                                                    ))}

                                                </li>}
                                                {/* </>
                                                    )
                                                })} */}

                                            </ul>
                                        </div>
                                    </div>
                                </div>


                                <div className={`up-green job-card ${item?.status === "Upcoming" && "up-yellow"} ${item?.status === "Cancelled" && "up-yellow up-red text-white"}`}>
                                    <div>
                                        <p className="mb-0"> {item?.status}</p>
                                        {item?.ratingOfJob !== 0
                                            ?
                                            <div><Rating initialValue={item?.ratingOfJob} allowFraction size={18} readonly /></div>
                                            : item?.status === 'Completed' &&
                                            <div className={`review-div`} onClick={() => navigate(`/review/${item?._id}`)}>
                                                Give a review
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }) : <div>No Bookings</div>}
                {jobList && jobList?.length > 0 && jobList?.length !== dataCount && <div className="load-upcoming text-center cursor-pointer mb-4" onClick={() => loadMoreData()}>
                    View more Bookings
                    <img src="/assets/images/black-arrow.png" alt="" />
                </div>}
            </div>
        </>
    );
};

export default BookingList;
